import { Injectable } from '@angular/core';
import { FuiModalService } from 'ngx-fomantic-ui';
import { Observable } from 'rxjs';
import { IConfirmModalContext, IModalOptions, ConfirmModal, InputPadModal, IInputModalContext } from '../../../public-api';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private modal: FuiModalService) { }

  confirmModal(context: IConfirmModalContext, options: IModalOptions = {}) : Observable<void> {
    return Observable.create((o) => {
        this.modal.open(new ConfirmModal(context, options))
            .onApprove(() => {
                o.next();
                o.complete();
            })
            .onDeny(() => {
                o.error();
                o.complete();
            });
    });
  }

  inputPad<T>(context: IInputModalContext, options: IModalOptions = {}) : Observable<T> {
    return Observable.create((o) => {
      this.modal.open(new InputPadModal(context, options))
        .onApprove((value: T) => {
          o.next(value);
          o.complete();
        })
        .onDeny(() => {
          o.error();
          o.complete();
      });
    });
  }
}
